import { db } from '../../config/Firebase'
import { Action } from './types'
import { addImagesToQueue, processUploadQueue } from './imageActions'
import { BACKEND_URL } from '../../config/constants'

export const createRequest = (params) => {
    return async (dispatch, getState) => {
        dispatch({ type: Action.REQUEST_RESET })
        const { user } = getState()
        //console.log("user request: ", user)
        const request = {
            uid: user.session.uid,
            email: user.session.email,
            date_created: new Date().getTime(),
            date_updated: null,
            plantType: params.plantType,
            images: null,
            survey: null
        }
        //console.log("request: ", request)
        db.collection('requests').add(request)
            .then(function (docRef) {
                dispatch({
                    type: Action.REQUEST_CREATE,
                    payload: {
                        rid: docRef.id,
                        uid: request.uid,
                        date_created: request.date_created,
                        plantType: request.plantType,
                    }
                })
            })
            .catch(function (error) {
                dispatch({ type: Action.REQUEST_ERROR, payload: error })
            })
    }
}

export const deleteRequest = () => {
    return async (dispatch, getState) => {
        const { request } = getState()
        db.collection("requests").doc(request.rid).delete().then(function () {
            dispatch({ type: Action.REQUEST_RESET })
        }).catch(function (error) {
            console.error("Error removing document: ", error)
        });
    }
}

export const submitSurvey = (survey) => {
    return async (dispatch, getStore) => {
        
        const requestId = getStore().request.rid
        return db.collection('requests').doc(requestId).update({
                survey: survey
            })
            .then(function() {
                console.log("El registro se ingreso")
                dispatch({ type: Action.REQUEST_SURVEY_SENT, payload: survey })
            })
            .catch(function(error) {
                console.log("error: ", error)
                dispatch({ type: Action.REQUEST_ERROR, payload: error })
            })
    }
}

export const submitDiagnosis = (params) => {
    return async (dispatch, getStore) => {
        //console.log ("params: ", params)
        const { id, general, recommendations, images } = params
        await db.collection('requests').doc(id).update({
                "diagnosis.date": new Date().getTime(),
                "diagnosis.general": general,
                "diagnosis.recommendations": recommendations
            })
            .then(async function() {
                console.log("El registro se ingreso")
                //dispatch({ type: Action.ADMIN_DIAGNOSIS_SENT })
                //if (images.length > 0){
                if (images !== null){
                    dispatch(addImagesToQueue(images))
                    await dispatch(processUploadQueue())
                    return null
                }
                //const { email, uid } = getStore().admin.currentRequest.data
                const { requestArray, currentIndex } = getStore().requestList
                const { email, uid } = requestArray[currentIndex].data
                const notification = {
                    rid: id,
                    uid: uid,
                    type: "New Diagnosis",
                    userEmail: email,
                    created: new Date().getTime(),
                }
                
                dispatch(sendNotification(notification))
                dispatch({ type: Action.REQUEST_DIAGNOSIS_SENT })
                console.log("notification sent")
            })
            .catch(function(error) {
                console.log("error: ", error)
                //dispatch({ type: Action.ADMIN_DIAGNOSIS_ERROR, payload: error })
            })
    }
}

export const updatePayment = (paymentIntent) => {
    return async (dispatch, getStore) => {
        const { requestArray, currentIndex } = getStore().requestList
        const { id } = requestArray[currentIndex]
        await db.collection('requests').doc(id).update({
            "payment.data.paymentIntent": paymentIntent
        })
        .then( function() {
            dispatch({ type: Action.REQUESTS_UPDATE_PAYMENT, payload: paymentIntent })
        })
        .catch( function(error) {
            console.log("error: ", error)
        })
    }
}

export const sendNotification = (notification) => {
    return async (dispatch) => {
        db.collection('notifications').add(notification)
            .then(function (docRef) {
                //console.log("notification sent: ", docRef)
                dispatch({ type: Action.NOTIFICATION_SENT })
            })
            .catch(function (error) {
                console.log("error sending notification: ", error)
            })
    }
}